"use strict";
import React from "react";
import _ from "underscore";
import Account from "../api/account";
import classNames from "classnames";
import { Link } from "react-router";
import { isIndexerMode } from "./index_audit_split_mode";
function showStep(props, step) {
  var classes = classNames({
    "indexer-progress__item": true,
    "indexer-progress__item__url": step.url,
    "indexer-progress__item--clickable": step.url || stepClickable(props, step),
    "indexer-progress__item__active": props.stepNumber === step.number,
    "indexer-progress__item__completed": props.stepNumber > step.number
  });
  var click = () => onStepClicked(props, step);
  return /* @__PURE__ */ React.createElement("li", { className: classes, key: step.number, onClick: click }, stepElement(props, step));
}
function stepElement(props, step) {
  if (showLink(props, step)) {
    return /* @__PURE__ */ React.createElement(Link, { to: step.url }, stepContent(props, step));
  } else {
    return stepContent(props, step);
  }
}
function stepContent(props, step) {
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "indexer-progress__indicator" }, /* @__PURE__ */ React.createElement("div", { className: "indexer-progress__indicator-inner" }, "\xA0")), /* @__PURE__ */ React.createElement("span", null, " ", step.label), possibleTrailer(props, step));
}
function showLink(props, step) {
  return step.url && Number(props.stepNumber) !== step.number;
}
function possibleTrailer(props, step) {
  const lastStep = _.last(props.steps);
  if (lastStep && step.number !== lastStep.number) {
    return /* @__PURE__ */ React.createElement("hr", { className: "indexer-progress__trailer" });
  }
}
function stepClickable(props, step) {
  return props.onStepClicked && step.number <= props.stepNumber;
}
function onStepClicked(props, step) {
  if (props.onStepClicked && stepClickable(props, step)) {
    props.onStepClicked(step);
  }
}
function ProgressBar(props) {
  return /* @__PURE__ */ React.createElement("div", { "data-component": "ProgressBar", className: "document-indexer__progress" }, /* @__PURE__ */ React.createElement("div", { className: "indexer-progress__container" }, props.sidebarTrigger, /* @__PURE__ */ React.createElement("ul", { className: "indexer-progress__list" }, _.map(props.steps, (step) => showStep(props, step)))));
}
function batchUrl(props) {
  if (props.batchId && props.stepNumber === 4) {
    let onDone = "/dashboard";
    if (props.location && props.location.query.onDone) {
      onDone = props.location.query.onDone;
    }
    return "/index-document-batches/" + props.batchId + "?onDone=" + encodeURIComponent(onDone);
  } else {
    return null;
  }
}
function inIndexerMode(props) {
  return isIndexerMode(props.location);
}
function steps(props) {
  var allSteps = [
    { number: 0, label: stepLabel(props, 0) },
    { number: 1, label: stepLabel(props, 1) },
    { number: 2, label: stepLabel(props, 2) },
    {
      number: 3,
      label: stepLabel(props, 3),
      url: batchUrl(props)
    },
    { number: 4, label: stepLabel(props, 4) }
  ];
  return allSteps.filter((step) => Boolean(step.label));
}
function stepIndex3Label(props) {
  if (Account.hasRole("Factor")) {
    if (inIndexerMode(props)) {
      return "Assign Debtor";
    } else {
      return "Create and Submit Invoice";
    }
  } else {
    if (props.multiCarrier) {
      return `Assign Loads & ${Account.carrierTerm()}s`;
    } else {
      return "Assign Loads";
    }
  }
}
function stepIndex4Label(props) {
  if (Account.hasRole("Factor")) {
    if (inIndexerMode(props)) {
      return "Review";
    } else {
      return null;
    }
  } else {
    if (inIndexerMode(props)) {
      return null;
    } else {
      return "Confirm & Submit";
    }
  }
}
function stepLabel(props, stepIndex) {
  return [
    function() {
      return `Assign ${Account.carrierTerm()}`;
    },
    function() {
      return "Identify Documents";
    },
    function() {
      return "Group Documents";
    },
    () => {
      return stepIndex3Label(props);
    },
    () => {
      return stepIndex4Label(props);
    }
  ][stepIndex]();
}
function IndexerProgress(props) {
  return /* @__PURE__ */ React.createElement(
    ProgressBar,
    {
      steps: steps(props),
      onStepClicked: props.onStepClicked,
      stepNumber: props.stepNumber,
      sidebarTrigger: props.sidebarTrigger
    }
  );
}
var ReplyProgressBar = React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement(ProgressBar, { steps: this.steps, stepNumber: this.props.stepNumber });
  },
  steps: [
    { number: 1, label: "View Reply" },
    { number: 2, label: "Identify Documents" },
    { number: 3, label: "Validate & Accept" }
  ]
});
var NoDocumentsProgressBar = React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement(
      ProgressBar,
      {
        steps: this.steps,
        stepNumber: this.props.stepNumber,
        sidebarTrigger: this.props.sidebarTrigger
      }
    );
  },
  steps: [
    { number: 0, label: `Assign ${Account.carrierTerm()}` },
    { number: 1, label: "Respond or Complete" }
  ]
});
export { IndexerProgress, ReplyProgressBar, NoDocumentsProgressBar };
